import React, { useState, useEffect } from "react";
import styled from "styled-components";

// Container for the form with LED lights effect
const FormWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: box-shadow 0.3s ease;

  /* Garland effect */
  border: 3px solid transparent;
  background: linear-gradient(white, white),
    radial-gradient(circle, red, green, blue);
  background-clip: border-box;

  /* LED Lights positioning around the form */

  /* More LED lights around the form */
  .led {
    position: absolute;
    width: 20px; /* Increased size for better visibility */
    height: 20px;
    border-radius: 80%;
    animation: ledAnimation 1s ease-out infinite;
  }

  /* Position LED lights */
  .led1 {
    top: 10px;
    left: 10px;
    background-color: yellow;
  }
  .led2 {
    top: 15px;
    left: 35px;
    background-color: blue;
  }
  .led3 {
    top: 10px;
    left: 58px;
    background-color: green;
  }
  .led4 {
    top: 15px;
    left: 80px;
    background-color: red;
  }
  .led5 {
    top: 10px;
    left: 102px;
    background-color: yellow;
  }
  .led6 {
    top: 15px;
    left: 125px;
    background-color: orange;
  }
  .led7 {
    top: 10px;
    left: 148px;
    background-color: purple;
  }
  .led8 {
    top: 15px;
    left: 169px;
    background-color: red;
  }
  .led9 {
    top: 10px;
    left: 190px;
    background-color: blue;
  }
  .led10 {
    top: 15px;
    left: 211px;
    background-color: orange;
  }
  .led11 {
    top: 10px;
    left: 232px;
    background-color: green;
  }
  .led12 {
    top: 15px;
    left: 253px;
    background-color: yellow;
  }
  .led13 {
    top: 10px;
    left: 274px;
    background-color: red;
  }
  .led14 {
    top: 15px;
    left: 295px;
    background-color: purple;
  }
  .led15 {
    top: 10px;
    left: 315px;
    background-color: orange;
  }
  .led16 {
    top: 15px;
    left: 335px;
    background-color: blue;
  }
  .led17 {
    top: 10px;
    left: 355px;
    background-color: red;
  }
  .led18 {
    top: 15px;
    left: 376px;
    background-color: yellow;
  }
  .led19 {
    top: 10px;
    left: 398px;
    background-color: green;
  }
  .led20 {
    top: 15px;
    left: 417px;
    background-color: blue;
  }

  /* Class for when the LED lights are lit up */
  &.led-on .led {
    animation: ledLightUp 1s ease-out infinite;
  }

  /* LED glowing effect when active */
  @keyframes ledLightUp {
    0% {
      box-shadow: 0 0 15px rgba(255, 0, 0, 0.9); /* Stronger red glow */
    }
    50% {
      box-shadow: 0 0 25px rgba(0, 255, 0, 0.9); /* Stronger green glow */
    }
    100% {
      box-shadow: 0 0 35px rgba(0, 0, 255, 0.9); /* Stronger blue glow */
    }
  }

  /* LED animation on page load (for the lights to glow) */
  @keyframes ledAnimation {
    0% {
      box-shadow: 0 0 10px rgba(255, 0, 0, 0.4); /* Slight glow at the start */
    }
    50% {
      box-shadow: 0 0 20px rgba(0, 255, 0, 0.5); /* Stronger green glow */
    }
    100% {
      box-shadow: 0 0 30px rgba(0, 0, 255, 0.4); /* Stronger blue glow */
    }
  }
`;

// Title styling
const Title = styled.h2`
  text-align: center;
  font-family: "Arial", sans-serif;
  color: #333;
  margin-bottom: 20px;
`;

const Description = styled.p`
  text-align: center;
  font-family: "Arial", sans-serif;
  color: #555;
  font-size: 16px;
  margin-bottom: 20px; /* Add margin for spacing */
`;

// Label styling
const Label = styled.label`
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-bottom: 8px;
  display: block;
`;

// Styled input fields
const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 3px rgba(0, 123, 255, 0.5);
  }
`;

// Submit button styling
const Button = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #00802b; /* Green color for Christmas theme */
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    background-color: #218838;
  }
`;

// Error message styling
const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  text-align: center;
`;

// Main GreetingForm component
const GreetingForm = ({ onClick }) => {
  const [x, setX] = useState("");
  const [y, setY] = useState("");
  const [prompt, setPrompt] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const [audio] = useState(new Audio("/background.mp3"));
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    audio.loop = true;

    playing ? audio.play() : audio.pause();
  }, [playing, audio]);

  // Handle input changes
  const handleXChange = (e) => setX(e.target.value);
  const handleYChange = (e) => setY(e.target.value);
  const handlePromptChange = (e) => setPrompt(e.target.value);

  // Validate the inputs before submitting
  const validateInput = () => {
    const xNum = parseInt(x, 10);
    const yNum = parseInt(y, 10);

    if (isNaN(xNum) || isNaN(yNum)) {
      setError("Please enter valid numbers.");
      return false;
    }

    if (xNum < 3 || xNum > 20 || yNum < 3 || yNum > 20) {
      setError("Please enter numbers between 3 and 20.");
      return false;
    }

    setError(""); // Clear error if valid
    return true;
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateInput()) {
      setIsSubmitted(true); // Set the form as submitted to trigger the garland and LED animation
      onClick({ x, y, prompt }); // Pass form data to the parent
      setPlaying(true);
      // Reset the submission state after animation completes (if needed)
      setTimeout(() => setIsSubmitted(false), 1500); // Reset after 1.5 seconds (duration of the animation)
    }
  };

  return (
    <FormWrapper className={isSubmitted ? "led-on" : ""}>
      <Title>HO HO HO, Hyarchis coworkers! It's Santa! 🎅</Title>
      <Description>
        I need your help to find presents for the office. First, let’s tackle a
        team challenge — enter the maze size and help me place the gifts under
        the tree!
      </Description>
      <form onSubmit={handleSubmit}>
        <div>
          <Label htmlFor="x">Maze row count:</Label>
          <Input
            type="number"
            id="x"
            value={x}
            onChange={handleXChange}
            placeholder="example: 10"
            min="5"
            max="100"
            required
          />
        </div>
        <div>
          <Label htmlFor="y">Maze column count:</Label>
          <Input
            type="number"
            id="y"
            value={y}
            onChange={handleYChange}
            placeholder="example: 10"
            min="5"
            max="100"
            required
          />
        </div>
        {error && <ErrorMessage>{error}</ErrorMessage>}{" "}
        {/* Display error message */}
        <Button type="submit">It's time to slay 🎁</Button>
      </form>
      <div className="led led1"></div>
      <div className="led led2"></div>
      <div className="led led3"></div>
      <div className="led led4"></div>
      <div className="led led5"></div>
      <div className="led led6"></div>
      <div className="led led7"></div>
      <div className="led led8"></div>
      <div className="led led9"></div>
      <div className="led led10"></div>
      <div className="led led11"></div>
      <div className="led led12"></div>
      <div className="led led13"></div>
      <div className="led led14"></div>
      <div className="led led15"></div>
      <div className="led led16"></div>
      <div className="led led17"></div>
      <div className="led led18"></div>
      <div className="led led19"></div>
      <div className="led led20"></div>
    </FormWrapper>
  );
};

export default GreetingForm;
